/* Cognito Error Mapping */

interface CognitoError extends Error {
  code?: string;
  name: string;
  message: string;
}

const COGNITO_ERROR_MAP: Record<string, string> = {
  // Login errors
  NotAuthorizedException: 'cognito-error-incorrect-credentials',
  UserNotFoundException: 'cognito-error-user-not-found',
  UserNotConfirmedException: 'cognito-error-user-not-confirmed',
  PasswordResetRequiredException: 'cognito-error-password-reset-required',

  // Registration errors
  UsernameExistsException: 'cognito-error-user-exists',
  InvalidPasswordException: 'cognito-error-invalid-password',
  InvalidParameterException: 'cognito-error-invalid-parameter',

  // Verification errors
  CodeMismatchException: 'cognito-error-code-mismatch',
  ExpiredCodeException: 'cognito-error-code-expired',

  // Rate limiting
  LimitExceededException: 'cognito-error-too-many-attempts',
  TooManyRequestsException: 'cognito-error-too-many-requests',
  TooManyFailedAttemptsException: 'cognito-error-too-many-failed-attempts',

  // Network/Other
  NetworkError: 'cognito-error-network',
  NEW_PASSWORD_REQUIRED: 'cognito-error-new-password-required',
};

export function mapCognitoError(error: Error) {
  const cognitoError = error as CognitoError;
  const errorCode = cognitoError?.code || cognitoError?.name || cognitoError?.message || 'UnknownError';
  const mappedTranslationKey = COGNITO_ERROR_MAP[errorCode];

  let translationKey: string;

  if (mappedTranslationKey !== undefined) {
    translationKey = mappedTranslationKey;
  } else {
    const fallbackKey = (error as CognitoError)?.name || (error as CognitoError)?.message;

    translationKey = fallbackKey !== undefined ? fallbackKey : 'cognito-error-unknown';
  }

  const mappedError = new Error(translationKey);

  mappedError.name = errorCode;

  return mappedError;
}
